var map = {
	"./Inspektorat Utama_page-0002.jpg": 79989,
	"./Inspektorat Utama_page-0003.jpg": 84717,
	"./Inspektorat Utama_page-0004.jpg": 73468,
	"./Inspektorat Utama_page-0005.jpg": 42072,
	"./Inspektorat Utama_page-0006.jpg": 84782,
	"./Inspektorat Utama_page-0007.jpg": 32210,
	"./Inspektorat Utama_page-0008.jpg": 72598,
	"./Inspektorat Utama_page-0009.jpg": 16455,
	"./Inspektorat Utama_page-0010.jpg": 71610,
	"./document thumbnail/thumb-1.png": 15039,
	"./document thumbnail/thumb-2.png": 48476,
	"./document/contoh nomor 1.pdf": 15053,
	"./document/sample2.pdf": 64269,
	"./document/sample3 long long name document.pdf": 38652,
	"./video thumbnail/dummy.txt": 75742,
	"./video/dummy.txt": 16523
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61938;